// Quick-time presets for EnhancedDateTimePicker and the logic that decides which
// preset is currently selected, so the button highlight follows the chosen time.

export interface TimePreset {
  hour24: number;
  minute: number;
  label: string;
}

export const TIME_PRESETS: TimePreset[] = [
  { hour24: 9, minute: 0, label: '9:00 AM' },
  { hour24: 12, minute: 0, label: '12:00 PM' },
  { hour24: 15, minute: 0, label: '3:00 PM' },
  { hour24: 17, minute: 0, label: '5:00 PM' },
];

// 12-hour display fields to minutes-of-day, or null when incomplete/invalid.
export function selectedTimeMinutes(
  hour: string,
  minute: string,
  ampm: 'AM' | 'PM'
): number | null {
  if (!hour || !minute) return null;
  const h = parseInt(hour, 10);
  const m = parseInt(minute, 10);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  let h24 = h;
  if (ampm === 'PM' && h24 !== 12) h24 += 12;
  if (ampm === 'AM' && h24 === 12) h24 = 0;
  return h24 * 60 + m;
}

// Which quick-time button matches the current selection: a preset index, 'now'
// (matches the wall clock but no fixed preset), or null (custom/empty time).
export function activePreset(
  hour: string,
  minute: string,
  ampm: 'AM' | 'PM',
  nowMinutes: number | null
): number | 'now' | null {
  const sel = selectedTimeMinutes(hour, minute, ampm);
  if (sel === null) return null;
  const idx = TIME_PRESETS.findIndex((p) => p.hour24 * 60 + p.minute === sel);
  if (idx !== -1) return idx;
  if (nowMinutes !== null && sel === nowMinutes) return 'now';
  return null;
}
